import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import RequestActionButton from "./RequestActionButton";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { Box } from "@mui/material";

const RequestActionBox = ({ requestId, type, status, redirectBack = true, showApproveButton = true }) => (
  <Box sx={{ display: "flex", gap: 2 }}>
    <SecuredComponent permission={permissions.canRejectStaffRequest}>
      <RequestActionButton
        label={"Откажи"}
        action={"отхвърлите"}
        color={"error"}
        icon={<CancelRoundedIcon />}
        requestId={requestId}
        type={type}
        status={status}
        redirectBack={redirectBack}
      />
    </SecuredComponent>
    {showApproveButton && (
      <SecuredComponent permission={permissions.canApproveStaffRequest}>
        <RequestActionButton
          requestAction={"confirm"}
          action={"одобрите"}
          label={"Одобри"}
          color={"success"}
          requestId={requestId}
          type={type}
          status={status}
          icon={<CheckCircleOutlineRoundedIcon />}
          redirectBack={redirectBack}
          reasonOptionVisible={false}
        />
      </SecuredComponent>
    )}
  </Box>
);

export default RequestActionBox;
